



//const  ApiPath = "https://tom9.myexamo.com/tqwebsite";    // For .com website backend
const  ApiPath = "https://tom9.myexamo.com/tqaiwebsite";    // For AI backend

//const  ApiPath = "http://localhost:8080";

export default ApiPath;